import React from "react";
import { UserLearnerProgress } from "../../components/UserLearnerProgress";

const UserLearnerProgressPage: React.FC = () => {
  return <UserLearnerProgress />;
};

export default UserLearnerProgressPage;
